import APIService from '../api';

export type AlertType = 'square_popup' | 'loyalty_popup';
export type AlertStatus = 'active' | 'dismissed' | 'disabled';

export default class AlertsService extends APIService {
  async listAlerts() {
    const { data } = await this.get(`/admin/alert`);
    return data.rows as {
      status: AlertStatus;
      type: AlertType;
    }[];
  }

  dismissAlert(type: string, status: AlertStatus, obs?: string) {
    return this.put(`/admin/alert/${type}`, { obs, status });
  }

  getDeactivationWidgetFeatures() {
    return this.get(`/v2/admin/business/widget-deactivation/features`);
  }
}
